export default function deleteDiscountReducer
    (state = {error: null, success: null, processing: false}, action) {

    switch (action.type) {
        case 'DELETE_DISCOUNT_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'DELETE_DISCOUNT_ERROR':
            return {...state, ...{error: action.error}};

        case 'DELETE_DISCOUNT_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default:
            return state;
    }
}